import Rollbar from 'rollbar'

const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
})

export const logError = (subject, message, error) => {
  const { networkError } = error
  let errorMessage = ''
  if (networkError !== undefined) {
    errorMessage = networkError?.result?.errors[0]?.message
  }
  rollbar.error(`${subject} - ${message} : ${errorMessage}`)
  if (import.meta.env.MODE !== 'production') {
    console.error(`${subject} - ${message} : `, errorMessage)
  }
}

export default rollbar
